import { useDispatch, useSelector } from "react-redux";
import { openSuscriptionModal } from "../store/actions";


export default function usePremiumCheck() {
    const dispatch = useDispatch();
    const isUserPremium = useSelector((state) => state.general.isUserPremium);

    const premiumCheck = (onClickHandler, ...args) => {
        if (isUserPremium) {
            return () => onClickHandler(...args); // Ejecuta la función con los argumentos proporcionados
        } else {
            return () => dispatch(openSuscriptionModal()); // Abre el modal si no es premium
        }
    };

    return premiumCheck;
}
